import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faq = [
  {
    q: "Do you provide custom-sized enclosures?",
    a: "Yes, all products can be customized based on client requirements. We design and fabricate acoustic enclosures, drop-over enclosures, and containerized modules to fit precise site conditions and equipment dimensions.",
  },
  {
    q: "Can products meet CPCB-II noise limits?",
    a: "Yes, our acoustic enclosures are engineered for strict noise compliance, meeting both national standards (like CPCB-II for gensets in India) and relevant international acoustic requirements.",
  },
  {
    q: "Do you offer on-site installation?",
    a: "Yes, our experienced engineers provide full installation, mechanical setup, commissioning services, and on-site technical support for generators and prefabricated structures.",
  },
  {
    q: "What types of metal fabrication services do you offer?",
    a: "We specialize in high-precision metal fabrication including structural frames, skid bases, sheet-metal components, heavy-duty industrial assemblies, and customized pressure vessels using Carbon Steel, Stainless Steel, and Aluminium.",
  },
  {
    q: "What standards do your fuel tanks and pressure vessels comply with?",
    a: "Our industrial fuel tanks (e.g., diesel, HFO) and pressure vessels are designed and fabricated in strict compliance with relevant international codes such as ASME, API, and UL standards to ensure safety and quality.",
  },
  {
    q: "Do you provide maintenance contracts for generators?",
    a: "Yes, we offer comprehensive preventive and corrective maintenance contracts for diesel generators and power systems, available on an hourly basis (e.g., 500/1000 running hours) or an annual schedule.",
  },
  {
    q: "Can you handle turnkey projects for power generation?",
    a: "Absolutely. We offer complete end-to-end solutions, covering engineering design, fabrication of enclosures/skids, generator installation, ATS/AMF integration, testing, and final commissioning for turnkey power projects.",
  },
  {
    q: "What is ATS/AMF integration and why is it important?",
    a: "ATS (Automatic Transfer Switch) and AMF (Automatic Mains Failure) integration ensures the generator automatically starts and seamlessly switches the load from the main power supply during an outage, providing uninterrupted power and minimizing downtime.",
  },
  {
    q: "What is the typical lead time for custom generator enclosures?",
    a: "The lead time varies based on complexity and size, typically ranging from 4 to 8 weeks after design approval. We prioritize efficient production schedules to meet project deadlines.",
  },
  {
    q: "Do you provide engineering design services (CAD, FEA)?",
    a: "Yes, our engineering team provides advanced design services including 3D CAD modeling, Structural Analysis (FEA) for load calculations, thermal analysis, and acoustic simulation to optimize product performance before fabrication.",
  },
  {
    q: "Where are you located and what regions do you serve?",
    a: "We are headquartered in the Al Sajaa Industrial Area, Sharjah, UAE, and serve regional and international clients across the Middle East, Africa, and Asia for power generation, industrial manufacturing, and oil & gas sectors.",
  },
  {
    q: "What makes your acoustic enclosures superior to standard containers?",
    a: "Our acoustic enclosures are purpose-built with optimized ventilation for cooling, high-grade acoustic insulation material, heavy-duty anti-vibration mountings, and specialized access points for easy maintenance, resulting in superior noise attenuation and durability compared to standard modified containers.",
  },
];

export default function ServicesFAQ() {
  return (
    <Box sx={{ py: 10, background: "#f8f9ff" }}>
      <Container maxWidth="md">
        {/* ----- TITLE ----- */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: { xs: 3, md: 4 }, // smaller spacing on mobile
            textAlign: "center",
            color: "#1a237e",
            fontSize: { xs: "1.6rem", md: "2.2rem" }, // smoother scaling
            lineHeight: 1.3, // prevents text from looking cramped
            px: { xs: 2, md: 0 }, // small padding for narrow screens
          }}
        >
          Frequently Asked Questions
        </Typography>

        {/* ----- FAQ ACCORDIONS ----- */}
        {faq.map((item, i) => (
          <Accordion
            key={i}
            sx={{
              mb: 2,
              borderRadius: "12px !important",
              boxShadow: "0 4px 18px rgba(0,0,0,0.08)",
              "&::before": { display: "none" },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#d50000" }} />}
              sx={{
                background: "#fff",
                borderRadius: "12px",
                "& .MuiAccordionSummary-content": {
                  fontWeight: 700,
                  color: "#1a237e",
                },
              }}
            >
              <Typography fontWeight={700}>{item.q}</Typography>
            </AccordionSummary>

            <AccordionDetails
              sx={{
                background: "#fafbfd",
                borderRadius: "0 0 12px 12px",
                color: "#333",
                fontSize: "0.98rem",
                lineHeight: 1.7,
              }}
            >
              {item.a}
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
}
